import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contacto.css';

import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
} from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

export default function Contacto() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const FUNCTION_URL = "https://europe-west1-duxbyte.cloudfunctions.net/sendContactEmail"; // Cambia a tu URL

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(FUNCTION_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Error enviando el formulario');
      }

      setSuccess(true);
      setFormData({ name: '', email: '', message: '' });
    } catch (err) {
      setError(err.message);
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="contact-wrapper"
    >
      <div className="contact-box">
        <h2>Contáctanos</h2>

        <form className="contact-form" onSubmit={handleSubmit}>
          {error && <p style={{ color: 'red' }}>{error}</p>}
          {success && <p style={{ color: 'green' }}>Mensaje enviado correctamente.</p>}

          <input
            type="text"
            name="name"
            placeholder="Tu nombre"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder="Tu correo electrónico"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            rows="5"
            placeholder="Tu mensaje"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </form>

        {/* El resto de tu contenido sin cambios */}
        <div className="contact-content">
          <div className="contact-info">
            <ul className="info-list">
              <li className="info-item">
                <FaMapMarkerAlt className="icon" />
                <span>Jerez de la Frontera, Cádiz, España</span>
              </li>
              <li className="info-item">
                <FaPhoneAlt className="icon" />
                <a href="tel:+34666290795">+34 666 29 07 95</a>
              </li>
              <li className="info-item">
                <FaEnvelope className="icon" />
                <a href="mailto:duxbyteinformatica@gmail.com">duxbyteinformatica@gmail.com</a>
              </li>
              <li className="info-item horario">
                <FaClock className="icon" />
                <div>
                  <strong>Lunes–Viernes:</strong><br />
                  10:00–14:00 &nbsp;&nbsp;|&nbsp;&nbsp; 17:30–20:00<br />
                  <strong>Sábado–Domingo:</strong><br />
                  Cerrado
                </div>
              </li>
            </ul>
          </div>

          <div className="contact-map">
            <iframe
              title="Mapa Duxbyte"
              src="https://www.google.com/maps/embed?pb=!1m18...YOUR_MAP_EMBED_URL..."
              allowFullScreen=""
              loading="lazy"
            />
          </div>
        </div>
      </div>

      <div className="social-section">
        <p>Síguenos en nuestras redes sociales</p>
        <div className="social-icons">
          <a href="https://facebook.com/duxbyte" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://instagram.com/duxbyte" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://twitter.com/duxbyte" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <FaTwitter />
          </a>
          <a href="https://www.tiktok.com/@duxbyte" target="_blank" rel="noopener noreferrer" aria-label="Tiktok">
            <SiTiktok />
          </a>
        </div>
      </div>
    </motion.div>
  );
}
